import { IAtendimentoRepasseCaso } from "../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import {
    AtualizaDadosRepasseService,
    ListarCatorioService,
    ListarDadosRepasseService,
    ListarModalidadeService,
    ListarTiposContratoRepasseService,
    ListarVinculacaoService,
} from "../../../Services/Repasse/GestaoDadosRepasse/GestaoDadosRepasse";
import { Controller } from "../../Controller";

export async function GetCasoRepasseDadosController(ID_CASO: number) {
    return Controller(ListarDadosRepasseService(ID_CASO));
}

export async function AtualizaCasoRepasseDadosController(
    formData: IAtendimentoRepasseCaso
) {
    return Controller(AtualizaDadosRepasseService(formData));
}

export async function ListarVinculacaoController() {
    return Controller(ListarVinculacaoService());
}

export async function ListarModalidadeController() {
    return Controller(ListarModalidadeService());
}

export async function ListarCatorioController() {
    return Controller(ListarCatorioService());
}

export async function ListarTiposContratoRepasseController() {
    return Controller(ListarTiposContratoRepasseService());
}
